import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
   selector: 'samweb-text-with-overflow-tooltip',
   templateUrl: './text-with-overflow-tooltip.component.html',
   styleUrls: ['./text-with-overflow-tooltip.component.scss'],
})
export class TextWithOverflowTooltipComponent implements OnInit {
   @Input()
   public value: string;

   @Input()
   public searchValues: string[];

   @ViewChild('cellTooltipDirective')
   public cellTooltipDirective: TooltipDirective;

   @Input()
   public position: 'bottom' | 'top' | 'left' | 'right' | 'center' = 'top';

   constructor() {}

   ngOnInit(): void {}

   public showTooltip(e: MouseEvent): void {
      const element = e.target as HTMLElement;
      if (element.offsetWidth < element.scrollWidth) {
         this.cellTooltipDirective.show(element);
      } else {
         this.cellTooltipDirective.hide();
      }
   }

   public hideTooltip() {
      this.cellTooltipDirective.hide();
   }
}
